import { useTranslation } from 'react-i18next';
import {LinkErrors} from '../../models/User';
import { InvalidLinkContainer, InvalidLinkContent } from './style';

interface InvalidLinkProps {
  color : string;
  error: LinkErrors;
}

const InvalidLink = ({ error , color}: InvalidLinkProps) => {
  const { t } = useTranslation();

  return (
    <InvalidLinkContainer>
      <InvalidLinkContent color={color}>
        {error === "notavailable" ? (
          <div>
            <h3>{t('invalidLink.maxReachedTittle')}</h3>
            <p>
              <strong>{t('invalidLink.maxReached')}</strong>
            </p>
            <p>{t(`invalidLink.maxReachedNotify`)}</p>
          </div> ) :(
          <div>
            <h3>{t('invalidLink.oops')}</h3>
            <p>{t(`invalidLink.${error}`)}</p>
            <p>
              <strong>{t('invalidLink.request')}</strong>
            </p>
          </div>
        ) }

          {error === "notavailable" ? <img className={`error-used`} src={`/assets/img/error-used.svg`} alt={`Max verifications reached`} />
            : <img className={`error-${error}`} src={`/assets/img/error-${error}.svg`} alt={`Link ${error}`} />}

        <div className="footerLinkError">

          {/*<a href={"/"} className="button" >  {t('location.close')} </a>*/}


        </div>

      </InvalidLinkContent>
    </InvalidLinkContainer>
  );
};

export default InvalidLink;
